import { RootState } from "@/store";
import { settingName, Controllers, Language } from "@infoland/iprova-api";
import { ActionTree, GetterTree, MutationTree } from "vuex";

//define the settings that should always be fetched from API
const volatileSettings: string[] = [settingName.maintenance_mode, settingName.autologin];

// state type
export interface SettingsState {
    [key: string]: any;
}
export function initialize(): SettingsState {
    return {};
}
// getters for this store
const getters: GetterTree<SettingsState, RootState> = {};

// initial state
const state: SettingsState = initialize();

// mutations for this store
const mutations: MutationTree<SettingsState> = {
    setting(state: SettingsState, payload: { name: string; value: any }) {
        if (!volatileSettings.includes(payload.name)) {
            state[payload.name] = payload.value;
        }
    }
};

const actions: ActionTree<SettingsState, RootState> = {
    /**
     * Gets the setting
     * @param context The context of the action
     */
    async getSettingAsync<T>({ state, commit }, name: settingName): Promise<T> {
        if (state[name] !== undefined) {
            return state[name];
        } else {
            const value = await Controllers.SettingsController.getSettingAsync<T>(name, undefined, true);
            commit("setting", { name, value });
            return value;
        }
    }
};

// export the namespace
export const namespace = "settings";

// export the store 'module'
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
